/**
 * см. /.storybook/preview-head.html
 */
export default $;
